import { colors } from '../../../../config/heni-websites-config';

export const getTailwindColor = (color: string | undefined) => {
	const defaultColor = colors.gray[900];

	if (!color) {
		return defaultColor;
	}

	const colorParts = color.split('-');

	const tailwindColor =
		colors[colorParts[0] as keyof typeof colors]?.[
			colorParts[1] as keyof (typeof colors)[keyof typeof colors]
		];

	return tailwindColor || defaultColor;
};
